import React, { useContext, useEffect, useState } from 'react';
import { DataTableWrapper } from './DataTableWrapper';
import { PageHeader } from './PageHeader';
import { IPageState } from '../../pages/Devices/DeviceImport';
import { strings } from '../../services/Localization';
import { getAppBase } from '../../utils/consts';
import AppContext from '../../context/AppContext';
import { FileDropZone } from '../../pages/Devices/FileUploadZone';
import { toast } from 'react-toastify';
import { GenericDassQuery } from '../../services/BasicDassQueries';
import { useNavigate } from 'react-router';

type Props = {
  uploadUrl: string;
};

export const Import: React.FC<Props> = ({ uploadUrl }) => {
  const appContextObj = useContext(AppContext);
  const navigate = useNavigate();
  

  const PageStateInit: IPageState = {
    user: {},
    pageTitle: '',
    showDeviceList: false,
    allSelected: true,
    limit: 50,
    page: 0,
    totalPage: 0,
    breadCrumbArr: [
      { label: strings.NAV_DEVICES_ITEM, url: `${getAppBase()}/devices` },
      { label: strings.DEVICES_DATA_IMPORT, url: '' }
    ],
    nameIndex: 0,
  };

  const [pageState, setPageState] = useState<IPageState>(PageStateInit);

  useEffect(() => {
    setPageState(prevState => ({
      ...prevState,
      user: appContextObj?.user
    }));
  }, [appContextObj]);

  const uploadFile = async (file: File) => {
    const allowedFormats = ['jsonl'];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!allowedFormats.includes(fileExtension)) {
      toast.error('Only .jsonl file format is allowed.');
      return;
    }

    try {

      const text = await file.text();

      const response = await GenericDassQuery(uploadUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
        },
        data: text
      })

      if (response.status > 299) {
        throw { status: response.status, message: await response.data };
      } else {
        toast.success(`${strings.IMPORT_JOB_SUCCESS_MESSAGE} - ${response.data}`);
        navigate(`${getAppBase()}/import-jobs?search_jobUuid=${response.data}`);
      }
      
    } catch (error) {
      console.error('Import Data failed:', error);
      toast.error(strings.ERROR_PROCESSING_FILE);
    }
  };

  return (
    <DataTableWrapper>
      <PageHeader
        name="import-devices-data"
        breadCrumbArr={pageState.breadCrumbArr}
        pageButtons={[]}
      />
      <div className="mx-0 d-lg-flex border-bottom border-2 mb-2 " >
        <div className="d-flex w-100 align-items-center justify-content-center p-2" >
          <FileDropZone uploadFile={uploadFile} uploadMessage={strings.UPLOAD_JSONL_MSG} />
        </div>
      </div>
    </DataTableWrapper>
  );
};
